import type { SVGProps } from "react";

/** Figma careers dept chip icons (7253:48569–7253:48669). */
export function CareersDeptIconHomeWork(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 13 13" fill="none" aria-hidden {...props}>
      <g clipPath="url(#careers-homework-clip)">
        <path
          d="M0.501953 5.53541V10.5633H3.51866V8.04934H4.52424V10.5633H7.54095V5.53541L4.02145 3.02148L0.501953 5.53541ZM6.53538 9.55769H5.52981V7.04377H2.51309V9.55769H1.50752V6.05328L4.02145 4.25834L6.53538 6.05328V9.55769Z"
          fill="currentColor"
        />
        <path
          d="M9.55171 3.52148H8.54614V4.52705H9.55171V3.52148Z"
          fill="currentColor"
        />
        <path
          d="M9.55171 5.53711H8.54614V6.54268H9.55171V5.53711Z"
          fill="currentColor"
        />
        <path
          d="M9.55171 7.54492H8.54614V8.55049H9.55171V7.54492Z"
          fill="currentColor"
        />
        <path
          d="M5.02673 1.5127V2.50318L6.0323 3.22217V2.51827H10.5574V9.55726H8.54623V10.5628H11.5629V1.5127H5.02673Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="careers-homework-clip">
          <rect width="12.0668" height="12.0668" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CareersDeptIconPeople(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 9.59575 9.59138" fill="none" aria-hidden {...props}>
      <path
        d="M8.6301 6.32878C7.62255 5.81301 6.31514 5.39319 4.79783 5.39319C3.28052 5.39319 1.97311 5.81301 0.965563 6.32878C0.365835 6.63465 0 7.25237 0 7.92408V9.59135H9.59566V7.92408C9.59566 7.25237 9.22983 6.63465 8.6301 6.32878ZM8.3962 8.39187H1.19946V7.92408C1.19946 7.69618 1.3194 7.49227 1.51132 7.39631C2.22499 7.03047 3.37647 6.59266 4.79783 6.59266C6.21919 6.59266 7.37067 7.03047 8.08434 7.39631C8.27626 7.49227 8.3962 7.69618 8.3962 7.92408V8.39187Z"
        fill="currentColor"
      />
      <path
        d="M3.46641 4.79789H6.1292C6.85487 4.79789 7.41262 4.16217 7.31667 3.44249L7.12475 1.97313C6.93884 0.833633 5.94928 0 4.7978 0C3.64632 0 2.65677 0.833633 2.47086 1.97313L2.27894 3.44249C2.18299 4.16217 2.74073 4.79789 3.46641 4.79789ZM3.65832 2.15305C3.75428 1.6013 4.23406 1.19947 4.7978 1.19947C5.36155 1.19947 5.84133 1.6013 5.93729 2.15305L6.1292 3.59842H3.46641L3.65832 2.15305Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CareersDeptIconSell(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 15 15" fill="none" aria-hidden {...props}>
      <g clipPath="url(#careers-sell-clip)">
        <path
          d="M12.8896 6.85465L7.56307 1.52581C7.33988 1.30251 7.03223 1.17578 6.71252 1.17578H2.38737C1.72381 1.17578 1.18091 1.71893 1.18091 2.38277V6.70981C1.18091 7.02967 1.30759 7.33745 1.53681 7.56074L6.86333 12.8896C7.33384 13.3603 8.09995 13.3603 8.57046 12.8896L12.8956 8.56254C13.3661 8.09181 13.3661 7.33141 12.8896 6.85465ZM7.71388 12.0387L2.38737 6.70981V2.38277H6.71252L12.039 7.71161L7.71388 12.0387Z"
          fill="currentColor"
        />
        <path
          d="M3.89557 4.80169C4.3953 4.80169 4.80041 4.3964 4.80041 3.89645C4.80041 3.3965 4.3953 2.99121 3.89557 2.99121C3.39583 2.99121 2.99072 3.3965 2.99072 3.89645C2.99072 4.3964 3.39583 4.80169 3.89557 4.80169Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="careers-sell-clip">
          <rect width="14.1783" height="14.1783" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CareersDeptIconDataTable(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 13 13" fill="none" aria-hidden {...props}>
      <path
        d="M2.51363 10.5609C2.2371 10.5609 2.00037 10.4624 1.80344 10.2655C1.60652 10.0686 1.50806 9.83184 1.50806 9.55531V2.51631C1.50806 2.23978 1.60652 2.00305 1.80344 1.80613C2.00037 1.6092 2.2371 1.51074 2.51363 1.51074H9.55262C9.82915 1.51074 10.0659 1.6092 10.2628 1.80613C10.4597 2.00305 10.5582 2.23978 10.5582 2.51631V9.55531C10.5582 9.83184 10.4597 10.0686 10.2628 10.2655C10.0659 10.4624 9.82915 10.5609 9.55262 10.5609H2.51363ZM2.51363 4.18807H9.55262V2.51631H2.51363V4.18807ZM2.51363 6.87798H9.55262V5.19365H2.51363V6.87798ZM2.51363 9.55531H9.55262V7.88355H2.51363V9.55531ZM3.01641 3.84869V2.84312H4.02198V3.84869H3.01641ZM3.01641 6.5386V5.53303H4.02198V6.5386H3.01641ZM3.01641 9.2285V8.22293H4.02198V9.2285H3.01641Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CareersDeptIconAccountTree(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 13 13" fill="none" aria-hidden {...props}>
      <path
        d="M7.50746 10.4607V8.98598H5.54115V4.0702H4.55799V5.54493H1.11694V1.6123H4.55799V3.08704H7.50746V1.6123H10.9485V5.54493H7.50746V4.0702H6.5243V8.00282H7.50746V6.52809H10.9485V10.4607H7.50746ZM8.49062 4.56177H9.96535V2.59546H8.49062V4.56177ZM8.49062 9.47756H9.96535V7.51124H8.49062V9.47756ZM2.1001 4.56177H3.57483V2.59546H2.1001V4.56177Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CareersDeptIconAdsClick(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" aria-hidden {...props}>
      <path
        d="M7.80667 11.9933C5.68667 11.8933 4 10.1467 4 8C4 5.79333 5.79333 4 8 4C10.1467 4 11.8933 5.68667 11.9933 7.80667L10.5933 7.38667C10.32 6.20667 9.26 5.33333 8 5.33333C6.52667 5.33333 5.33333 6.52667 5.33333 8C5.33333 9.26 6.20667 10.32 7.38667 10.5933L7.80667 11.9933ZM14.6667 8C14.6667 8.2 14.66 8.4 14.64 8.6L13.3267 8.20667C13.3333 8.14 13.3333 8.06667 13.3333 8C13.3333 5.05333 10.9467 2.66667 8 2.66667C5.05333 2.66667 2.66667 5.05333 2.66667 8C2.66667 10.9467 5.05333 13.3333 8 13.3333C8.06667 13.3333 8.14 13.3333 8.20667 13.3267L8.6 14.64C8.4 14.66 8.2 14.6667 8 14.6667C4.32 14.6667 1.33333 11.68 1.33333 8C1.33333 4.32 4.32 1.33333 8 1.33333C11.68 1.33333 14.6667 4.32 14.6667 8ZM12.1533 10.84L14.6667 10L8 8L10 14.6667L10.84 12.1533L13.6867 15L15.0067 13.68L12.1533 10.84Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CareersDeptIconPalette(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 10.3068 10.3068" fill="none" aria-hidden {...props}>
      <path
        d="M5.15339 0C2.31387 0 0 2.31387 0 5.15339C0 7.9929 2.31387 10.3068 5.15339 10.3068C5.86455 10.3068 6.44173 9.72959 6.44173 9.01843C6.44173 8.70407 6.3232 8.40002 6.11192 8.15781C6.07069 8.10628 6.04492 8.04959 6.04492 7.98775C6.04492 7.84345 6.1583 7.73008 6.30259 7.73008H7.21474C8.92051 7.73008 10.3068 6.34382 10.3068 4.63805C10.3068 2.08197 7.9929 0 5.15339 0ZM7.98775 5.66872C7.56002 5.66872 7.21474 5.32345 7.21474 4.89572C7.21474 4.46799 7.56002 4.12271 7.98775 4.12271C8.41548 4.12271 8.76076 4.46799 8.76076 4.89572C8.76076 5.32345 8.41548 5.66872 7.98775 5.66872ZM6.44173 3.60737C6.014 3.60737 5.66872 3.26209 5.66872 2.83436C5.66872 2.40663 6.014 2.06135 6.44173 2.06135C6.86946 2.06135 7.21474 2.40663 7.21474 2.83436C7.21474 3.26209 6.86946 3.60737 6.44173 3.60737ZM1.54602 4.89572C1.54602 4.46799 1.89129 4.12271 2.31902 4.12271C2.74675 4.12271 3.09203 4.46799 3.09203 4.89572C3.09203 5.32345 2.74675 5.66872 2.31902 5.66872C1.89129 5.66872 1.54602 5.32345 1.54602 4.89572ZM4.63805 2.83436C4.63805 3.26209 4.29277 3.60737 3.86504 3.60737C3.43731 3.60737 3.09203 3.26209 3.09203 2.83436C3.09203 2.40663 3.43731 2.06135 3.86504 2.06135C4.29277 2.06135 4.63805 2.40663 4.63805 2.83436Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CareersDeptIconStackedBar(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" aria-hidden {...props}>
      <path d="M10.6666 6H13.3333V13.3333H10.6666V6Z" fill="currentColor" />
      <path
        d="M10.6666 2.66699H13.3333V5.33366H10.6666V2.66699Z"
        fill="currentColor"
      />
      <path
        d="M6.66659 4.66699H9.33325V7.33366H6.66659V4.66699Z"
        fill="currentColor"
      />
      <path
        d="M2.66659 6.66699H5.33325V9.33366H2.66659V6.66699Z"
        fill="currentColor"
      />
      <path d="M2.66659 10H5.33325V13.3333H2.66659V10Z" fill="currentColor" />
      <path d="M6.66659 8H9.33325V13.3333H6.66659V8Z" fill="currentColor" />
    </svg>
  );
}
